import type { FeatureEvents, ScreenEvent } from '../new-analytics-types';

type ScreenKeys = 'confirmationWarningModalScreen';

const confirmationWarningModalScreen = 'confirmationWarningModalScreen';

export const confirmationWarningModalEvents: FeatureEvents<ScreenKeys, string, string, string> = {
  confluenceSpec: '',
  screen: {
    confirmationWarningModalScreen: (attributes: { modalName: string }): ScreenEvent => ({
      data: {
        name: confirmationWarningModalScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/90711',
    }),
  },
  ui: {},
  track: {},
  operational: {},
};
